import { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = "", onClick }: CardProps) {
  const baseClasses = "bg-white rounded-xl p-5 border border-slate-200 shadow-sm";
  const clickableClasses = onClick
    ? "cursor-pointer hover:border-slate-300 hover:shadow transition-all"
    : "";

  return (
    <div
      className={`${baseClasses} ${clickableClasses} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
